import { Button, DatePicker, Modal, Segmented, Table, Tag } from "antd";
import Search from "antd/es/transfer/search";
import "bootstrap-icons/font/bootstrap-icons.css";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import {
  cancelLeaveApplication,
  countLeaveApplication,
  loadAllLeaveApplication,
  loadLeaveApplicationByStatus,
} from "../../redux/rtk/features/leave/leaveSlice";
import getPermissions from "../../utils/getPermissions";
import getUserFromToken from "../../utils/getUserFromToken";
import ViewBtn from "../Buttons/ViewBtn";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { GreenLinkBtn } from "../UI/AllLinkBtn";
import BtnAllSvg from "../UI/Button/btnAllSvg";
import BtnViewSvg from "../UI/Button/btnViewSvg";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";

function CustomTable({ list, total }) {
  const dispatch = useDispatch();
  const [status, setStatus] = useState("true");
  const [columnsToShow, setColumnsToShow] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [filteredList, setFilteredList] = useState([]);
  const overlap = useSelector((state) => state.leave.overlappingLeaves);
  const { RangePicker } = DatePicker;
  const [dateRange, setDateRange] = useState([null, null]);
  // useEffect(() => {
  // 	if (list) {
  // 		const filtered = list.filter(item => {
  // 			const fullName = `${item.user?.firstName} ${item.user?.lastName}`.toLowerCase();
  // 			return fullName.includes(searchText.toLowerCase());
  // 		});
  // 		setFilteredList(filtered);
  // 	}
  // }, [list, searchText]);

  useEffect(() => {
    if (list) {
      console.log("Raw Input:", {
        dateRange,
        list: list.map((item) => ({
          leaveFrom: item.leaveFrom,
          leaveTo: item.leaveTo,
        })),
      });
      const filtered = list.filter((item) => {
        const fullName =
          `${item.user?.firstName} ${item.user?.lastName}`.toLowerCase();
        const matchesName = fullName.includes(searchText.toLowerCase());

        const leaveStart = dayjs(item.leaveFrom).startOf("day");
        const leaveEnd = dayjs(item.leaveTo).startOf("day");
        const [startDate, endDate] = dateRange || [];

        const rangeStart = startDate ? dayjs(startDate).startOf("day") : null;
        const rangeEnd = endDate ? dayjs(endDate).startOf("day") : null;

        console.log("Raw dates for item:", {
          leaveFrom: leaveStart,
          leaveTo: leaveEnd,
          rangeStart: rangeStart,
          rangeEnd: rangeEnd,
        });
        // console.log("RangeStart", startDate, "RangeEnd", endDate, "leaveStart", leaveStart, "leaveEnd", leaveEnd);
        console.log("Parsed dates:", {
          leaveStart: startDate?.format("YYYY-MM-DD"),
          leaveEnd: endDate?.format("YYYY-MM-DD"),
        });
        const matchesDate =
          !rangeStart ||
          !rangeEnd ||
          leaveStart.isBetween(rangeStart, rangeEnd, null, "[]") ||
          leaveEnd.isBetween(rangeStart, rangeEnd, null, "[]") ||
          leaveStart.isSame(rangeStart) ||
          leaveEnd.isSame(rangeEnd) ||
          (leaveStart.isSame(rangeEnd) && leaveEnd.isSame(rangeStart)) ||
          (leaveStart.isBefore(rangeStart) && leaveEnd.isAfter(rangeEnd));

        // const matchesDate = (!rangeStart || leaveStart.isAfter(startDate) || leaveStart.isSame(startDate)) &&
        // 	(!endDate || leaveEnd.isBefore(endDate) || leaveEnd.isSame(endDate));

        return matchesName && matchesDate;
      });

      setFilteredList(filtered);
    }
  }, [list, searchText, dateRange]);

  const handleCancelLeave = (id) => {
    Modal.confirm({
      title: "Confirm Cancellation",
      content: "Are you sure you want to cancel this leave application?",
      okText: "Yes",
      cancelText: "No",
      onOk: async () => {
        try {
          const result = await dispatch(cancelLeaveApplication({ id })).unwrap();
          if (result.message === "success") {
            dispatch(loadAllLeaveApplication());
          }
        } catch (error) {
          console.error("Cancellation failed:", error);
        }
      },
    });
  };

  const columns = [
    {
      id: 1,
      title: "S.No",
      dataIndex: "serial",
      key: "serial",
    },

    {
      id: 2,
      title: " Name",
      key: "name",
      dataIndex: "user",
      render: ({ firstName, lastName }) => firstName + " " + lastName,
    },
    {
      id: 3,
      title: "Leave Type",
      dataIndex: "leavePolicy",
      key: "leavePolicy",
      render: (leavePolicy) => leavePolicy?.name || "N/A",
    },
    {
      id: 4,
      title: "Leave From",
      dataIndex: "leaveFrom",
      key: "leaveFrom",
      render: (leaveFrom) => dayjs(leaveFrom).format("DD-MM-YYYY"),
    },
    {
      id: 5,
      title: "Leave To",
      dataIndex: "leaveTo",
      key: "leaveTo",
      render: (leaveTo) => dayjs(leaveTo).format("DD-MM-YYYY"),
    },
    {
      id: 6,
      title: "Leave Duration",
      dataIndex: "totalleaveDays",
      key: "totalleaveDays",
      // render: (leaveDuration) => {
      // 	if (leaveDuration > 0) {
      // 		return <span>{leaveDuration} days</span>;
      // 	} else {
      // 		return <span>{leaveDuration} day</span>;
      // 	}
      // },
    },
    {
      id: 7,
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        if (!status) {
          return <Tag color="gray">UNKNOWN</Tag>;
        }
        if (status === "ACCEPTED") {
          return <Tag color="green">{status.toUpperCase()}</Tag>;
        } else if (status === "REJECTED") {
          return <Tag color="red">{status.toUpperCase()}</Tag>;
        } 
		else if (status === "CANCELED") {
			return <Tag color="red">{status.toUpperCase()}</Tag>;
		  }
		else {
          return <Tag color="orange">{status.toUpperCase()}</Tag>;
        }
      },
    },

    // {
    // 	id: 7,
    // 	title: "Action",
    // 	key: "action",
    // 	render: ({ id }) => (
    // 		<ViewBtn
    // 			path={`/admin/leave/${id}`}
    // 			text='View'
    // 			icon={<BtnViewSvg />}
    // 		/>
    // 	),
    // },
    {
      id: 8,
      title: "Action",
      key: "action",
      render: ({ id, status }) => (
        <div className="flex gap-2">
          <ViewBtn
            path={`/admin/leave/${id}`}
            text="View"
            icon={<BtnViewSvg />}
          />
          {status === "ACCEPTED" && (
            <Button
              type="danger"
              size="small"
              onClick={() => handleCancelLeave(id)}
              // loading={cancelLoading}
            >
              Cancel
            </Button>
          )}
        </div>
      ),
    },
  ];
  //make a onChange function
  const onChange = (value) => {
    setStatus(value);
    dispatch(
      loadLeaveApplicationByStatus({ page: 1, limit: 20, status: value })
    );
  };

  useEffect(() => {
    setColumnsToShow(columns);
  }, []);

  const columnsToShowHandler = (val) => {
    setColumnsToShow(val);
  };

  const onAllClick = () => {
    dispatch(loadAllLeaveApplication());
    setStatus("all");
  };

  // const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));
  const addKeys = (arr) =>
    arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));

  return (
    <div className="ant-card p-4 rounded mt-0">
      <div className="flex my-2 justify-between">
        <div className="w-50">
          <h4 className="text-2xl mb-2"> Leave Applications</h4>
        </div>
        {list && (
          <div className="flex justify-end mr-4">
            <div className="mt-0.5">
              <CsvLinkBtn>
                <CSVLink
                  // data={list}
                  data={list.map((item, index) => ({
                    sNo: index + 1,
                    name:
                      item.user?.firstName && item.user?.lastName
                        ? `${item.user.firstName} ${item.user.lastName}`
                        : "N/A",
                    leaveType: item.leavePolicy?.name || "N/A",
                    leaveFrom: item.leaveFrom
                      ? dayjs(item.leaveFrom).format("DD-MM-YYYY")
                      : "N/A",
                    leaveTo: item.leaveTo
                      ? dayjs(item.leaveTo).format("DD-MM-YYYY")
                      : "N/A",
                    totalleaveDays: item.totalleaveDays ?? "N/A",
                    acceptLeaveFrom: item.acceptLeaveFrom
                      ? dayjs(item.acceptLeaveFrom).format("DD-MM-YYYY")
                      : "N/A",
                    acceptLeaveTo: item.acceptLeaveTo
                      ? dayjs(item.acceptLeaveTo).format("DD-MM-YYYY")
                      : "N/A",
                    status: item.status || "N/A",
                  }))}
                  headers={[
                    { label: "S.No", key: "sNo" },
                    { label: "Name", key: "name" },
                    { label: "Leave Type", key: "leaveType" },
                    { label: "Leave From", key: "leaveFrom" },
                    { label: "Leave To", key: "leaveTo" },
                    { label: "Leave Duration", key: "totalleaveDays" },
                    { label: "Accepted Leave From", key: "acceptLeaveFrom" },
                    { label: "Accepted Leave To", key: "acceptLeaveTo" },
                    { label: "Status", key: "status" },
                  ]}
                  className="btn btn-dark btn-sm"
                  style={{ marginTop: "5px" }}
                  filename="leave_applications"
                >
                  Download CSV
                </CSVLink>
              </CsvLinkBtn>
            </div>

            <div className="ml-2 mt-0.5">
              <GreenLinkBtn>
                <button onClick={onAllClick}>
                  <BtnAllSvg size={15} title={"ALL"} />
                </button>
              </GreenLinkBtn>
            </div>

            <div>
              <Segmented
                className="text-center rounded text-red-500"
                size="middle"
                defaultValue={"ACCEPTED"}
                options={[
                  {
                    label: (
                      <span>
                        <i className="bi bi-person-lines-fill"></i> Accepted
                      </span>
                    ),
                    value: "ACCEPTED",
                  },
                  {
                    label: (
                      <span>
                        <i className="bi bi-person-dash-fill"></i> Pending
                      </span>
                    ),
                    value: "PENDING",
                  },
                ]}
                value={status}
                onChange={onChange}
              />
            </div>
          </div>
        )}
      </div>
      {list && (
        <div
          style={{
            marginBottom: "30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <ColVisibilityDropdown
            options={columns}
            columns={columns}
            columnsToShowHandler={columnsToShowHandler}
          />
          <div style={{ marginLeft: "auto", display: "flex", gap: "10px" }}>
            <RangePicker
              format="DD-MM-YYYY"
              onChange={(dates) => setDateRange(dates)}
              allowClear
              style={{ marginRight: "10px" }}
            />
            <Search
              placeholder="Search by name..."
              allowClear
              size="large"
              onChange={(e) => setSearchText(e.target.value)}
              style={{ maxWidth: "400px" }}
            />
          </div>
        </div>
      )}

      <Table
        className="text-center"
        scroll={{ x: true }}
        loading={!list}
        pagination={{
          // defaultPageSize: 20,
          // pageSizeOptions: [10, 20, 50, 100, 200],
          // showSizeChanger: true,
          // total: total ? total : 100,
          pagination: false,
          onChange: () => {
            // dispatch(loadLeaveApplicationByStatus({ page, limit, status }));
            dispatch(loadAllLeaveApplication({}));
          },
        }}
        columns={columnsToShow}
        dataSource={filteredList ? addKeys(filteredList) : []}
      />
    </div>
  );
}

const GetAllLeaves = (props) => {
  const dispatch = useDispatch();
  const list = useSelector((state) => state.leave.list);
  const total = useSelector((state) => state.leave.total);
  const userId = getUserFromToken();
  const permissions = getPermissions();
  const hasPermission = (item) => {
    return permissions?.includes(item ? item : "");
  };

  const filteredList = list.filter(
    (item) => item.reportingManagerId === userId
  );

  const dataToShow = hasPermission("show-menu") ? filteredList : list;

  useEffect(() => {
    dispatch(loadAllLeaveApplication());
    dispatch(countLeaveApplication());
  }, []);

  return (
    <UserPrivateComponent permission={"readAll-leaveApplication"}>
      {/* <div className='card card-custom'> */}
      <div>
        <div className="card-body">
          {/* <CustomTable list={list} total={total} /> */}
          <CustomTable list={dataToShow} total={total} />
        </div>
      </div>
    </UserPrivateComponent>
  );
};

export default GetAllLeaves;
